var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 172,
    viewBox: "0 0 177 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.372 77.1089C163.893 77.1089 162.689 78.3124 162.689 79.7917C162.689 81.2705 163.893 82.4745 165.372 82.4745C166.851 82.4745 168.055 81.2705 168.055 79.7917C168.055 78.3124 166.851 77.1089 165.372 77.1089ZM165.372 84.2527C162.912 84.2527 160.911 82.2514 160.911 79.7917C160.911 77.3315 162.912 75.3307 165.372 75.3307C167.832 75.3307 169.833 77.3315 169.833 79.7917C169.833 82.2514 167.832 84.2527 165.372 84.2527Z",
    fill: "#67E2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.712 7.85591L102.932 12.7972L106.584 8.59611L100.712 7.85591ZM102.485 15.824L98.0044 5.85291L109.855 7.3465L102.485 15.824Z",
    fill: "#108DA0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_2839",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 122,
    width: 18,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.737 122.438H176.624V141.385H159.737V122.438Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_2839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.367 141.385L159.737 141.142L160.734 134.456L167.053 135.057L164.005 122.438L176.625 129.487L175.821 130.927L166.493 125.715L169.197 136.919L162.134 136.245L161.367 141.385Z",
    fill: "#67E2C2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81311 131.447V135.486C3.81311 136.289 4.46649 136.942 5.26934 136.942H9.50065C10.3035 136.942 10.9569 136.289 10.9569 135.486V131.447H3.81311ZM9.50065 138.59H5.26934C3.55759 138.59 2.16455 137.197 2.16455 135.486V130.622C2.16455 130.167 2.53328 129.798 2.98883 129.798H11.7812C12.2367 129.798 12.6054 130.167 12.6054 130.622V135.486C12.6054 137.197 11.2124 138.59 9.50065 138.59Z",
    fill: "#67E2C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6054 129.798H10.9569V87.8343L7.385 80.7334L3.81311 87.8343V129.248H2.16455V87.6381C2.16455 87.5096 2.19477 87.3826 2.25247 87.2678L6.64864 78.5287C6.78877 78.2501 7.07342 78.0748 7.385 78.0748C7.69658 78.0748 7.98123 78.2501 8.12136 78.5287L12.5175 87.2678C12.5752 87.3826 12.6054 87.5096 12.6054 87.6381V129.798Z",
    fill: "#67E2C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_802_2839",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 177,
    height: 172
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 171.561H176.624V0H0V171.561Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_802_2839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56079 79.242H8.20935V76.4944H6.56079V79.242Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26367 88.5839H9.3084V86.9353H3.26367V88.5839Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.5 153.427H143.391V86.9353H133.5V153.427Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0911 153.427H38.9824V86.9353H29.0911V153.427Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4673 103.919H56.823V88.5631C56.823 87.2009 56.8626 85.9386 56.9428 84.7764C56.6625 85.077 56.3619 85.3578 56.0416 85.6177C55.0195 86.4695 53.9028 87.391 52.6906 88.3829L51.2783 86.5645L57.2285 81.9513H59.4673V103.919Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3612 92.9054C70.3612 96.091 70.7244 98.3897 71.4503 99.8025C72.1768 101.215 73.3313 101.921 74.914 101.921C76.5169 101.921 77.6813 101.198 78.4078 99.7497C79.1337 98.3023 79.497 96.0212 79.497 92.9054C79.497 89.8204 79.1337 87.5515 78.4078 86.0985C77.6813 84.6467 76.5169 83.9197 74.914 83.9197C73.311 83.9197 72.1515 84.6313 71.4355 86.0535C70.7189 87.4762 70.3612 89.76 70.3612 92.9054ZM82.2319 92.9054C82.2319 96.7219 81.628 99.5618 80.4213 101.425C79.214 103.289 77.3786 104.22 74.914 104.22C72.5296 104.22 70.7217 103.261 69.4896 101.343C68.2576 99.4244 67.6416 96.612 67.6416 92.9054C67.6416 89.0791 68.2351 86.2392 69.422 84.3857C70.609 82.5327 72.4395 81.6062 74.914 81.6062C77.2983 81.6062 79.1139 82.5679 80.3608 84.4906C81.6082 86.414 82.2319 89.2193 82.2319 92.9054Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6582 103.919H92.0139V88.5631C92.0139 87.2009 92.0535 85.9386 92.1337 84.7764C91.8534 85.077 91.5529 85.3578 91.2325 85.6177C90.2104 86.4695 89.0937 87.391 87.8815 88.3829L86.4692 86.5645L92.4194 81.9513H94.6582V103.919Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.552 92.9054C105.552 96.091 105.915 98.3897 106.641 99.8025C107.368 101.215 108.522 101.921 110.105 101.921C111.708 101.921 112.872 101.198 113.599 99.7497C114.325 98.3023 114.688 96.0212 114.688 92.9054C114.688 89.8204 114.325 87.5515 113.599 86.0985C112.872 84.6467 111.708 83.9197 110.105 83.9197C108.502 83.9197 107.342 84.6313 106.626 86.0535C105.91 87.4762 105.552 89.76 105.552 92.9054ZM117.423 92.9054C117.423 96.7219 116.819 99.5618 115.612 101.425C114.405 103.289 112.569 104.22 110.105 104.22C107.721 104.22 105.913 103.261 104.681 101.343C103.449 99.4244 102.833 96.612 102.833 92.9054C102.833 89.0791 103.426 86.2392 104.613 84.3857C105.8 82.5327 107.63 81.6062 110.105 81.6062C112.489 81.6062 114.305 82.5679 115.552 84.4906C116.799 86.414 117.423 89.2193 117.423 92.9054Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2918 126.873C56.2918 130.059 56.6551 132.357 57.381 133.77C58.1075 135.183 59.262 135.889 60.8446 135.889C62.4476 135.889 63.612 135.165 64.3385 133.718C65.0644 132.27 65.4276 129.989 65.4276 126.873C65.4276 123.788 65.0644 121.519 64.3385 120.066C63.612 118.614 62.4476 117.887 60.8446 117.887C59.2417 117.887 58.0822 118.599 57.3662 120.021C56.6496 121.444 56.2918 123.728 56.2918 126.873ZM68.1626 126.873C68.1626 130.69 67.5587 133.53 66.3519 135.393C65.1446 137.256 63.3092 138.188 60.8446 138.188C58.4603 138.188 56.6523 137.229 55.4203 135.311C54.1883 133.392 53.5723 130.58 53.5723 126.873C53.5723 123.047 54.1657 120.207 55.3527 118.353C56.5397 116.5 58.3701 115.574 60.8446 115.574C63.229 115.574 65.0446 116.536 66.2915 118.458C67.5389 120.382 68.1626 123.187 68.1626 126.873Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5889 137.887H77.9446V122.531C77.9446 121.169 77.9841 119.906 78.0644 118.744C77.7841 119.045 77.4835 119.326 77.1631 119.585C76.141 120.437 75.0244 121.359 73.8122 122.351L72.3999 120.532L78.3501 115.919H80.5889V137.887Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4825 126.873C91.4825 130.059 91.8458 132.357 92.5717 133.77C93.2981 135.183 94.4527 135.889 96.0353 135.889C97.6382 135.889 98.8027 135.165 99.5292 133.718C100.255 132.27 100.618 129.989 100.618 126.873C100.618 123.788 100.255 121.519 99.5292 120.066C98.8027 118.614 97.6382 117.887 96.0353 117.887C94.4323 117.887 93.2729 118.599 92.5568 120.021C91.8403 121.444 91.4825 123.728 91.4825 126.873ZM103.353 126.873C103.353 130.69 102.749 133.53 101.543 135.393C100.335 137.256 98.4999 138.188 96.0353 138.188C93.6509 138.188 91.843 137.229 90.611 135.311C89.379 133.392 88.7629 130.58 88.7629 126.873C88.7629 123.047 89.3564 120.207 90.5434 118.353C91.7304 116.5 93.5608 115.574 96.0353 115.574C98.4197 115.574 100.235 116.536 101.482 118.458C102.73 120.382 103.353 123.187 103.353 126.873Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.78 137.887H113.135V122.531C113.135 121.169 113.175 119.906 113.255 118.744C112.975 119.045 112.674 119.326 112.354 119.585C111.332 120.437 110.215 121.359 109.003 122.351L107.591 120.532L113.541 115.919H115.78V137.887Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9416 154.526C92.275 155.419 91.0474 156.269 89.6263 157.274H83.4684C82.0473 156.269 80.1531 154.526 80.1531 154.526H16.4521V155.484C16.4521 159.204 19.4674 162.22 23.1876 162.22H149.294C153.014 162.22 156.03 159.204 156.03 155.484V154.526H92.9416Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.334 153.977H38.9825V68.8011H37.334V153.977Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3147 64.4049H103.826V62.7563H59.3147V64.4049Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.95 153.977H134.599V76.4944H132.95V153.977Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3978 153.977H19.7493V84.878C19.7493 81.7704 22.2776 79.2421 25.3846 79.2421H38.433V80.8906H25.3846C23.1865 80.8906 21.3978 82.6793 21.3978 84.878V153.977Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.184 153.427H150.535V84.878C150.535 82.6793 148.746 80.8906 146.548 80.8906H133.5V79.2421H146.548C149.655 79.2421 152.184 81.7704 152.184 84.878V153.427Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0909 154.526H27.4424V88.241C27.4424 87.5205 28.0276 86.9353 28.7475 86.9353H34.0366V88.5839H29.0909V154.526Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.49 154.526H142.842V88.5839H137.896V86.9353H143.185C143.905 86.9353 144.49 87.5205 144.49 88.241V154.526Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.452 155.076V155.209C16.452 158.468 19.104 161.12 22.3638 161.12H148.47C151.73 161.12 154.382 158.468 154.382 155.209V155.076H93.2651C92.5046 156.499 91.2511 157.438 89.6103 157.804L89.4306 157.823L83.093 157.804C81.7225 157.497 80.1827 155.811 79.5656 155.076H16.452ZM148.47 162.769H22.3638C18.1951 162.769 14.8035 159.377 14.8035 155.209V153.427H80.3596L80.6075 153.745C81.2977 154.629 82.5896 155.936 83.3771 156.175H89.3361C90.5945 155.87 91.4858 155.115 91.9864 153.931L92.1991 153.427H156.03V155.209C156.03 159.377 152.639 162.769 148.47 162.769Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.688 162.769H161.526V161.121H146.688V162.769Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0559 162.769H26.893V161.121H12.0559V162.769Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5862 171.562H38.4328V169.913H34.5862V171.562Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8291 171.562H141.193V169.913H42.8291V171.562Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2377 59.177C35.4399 59.177 35.6377 59.2512 35.791 59.3908C37.4006 60.8481 39.2228 61.9817 41.2076 62.7599C44.846 64.1996 48.2124 64.082 50.4682 63.6995C49.1581 62.2812 47.648 60.0337 47.1765 56.8987C46.9155 55.2419 46.9919 53.5416 47.404 51.8442C47.4359 51.7112 47.5008 51.5881 47.5925 51.4864C52.0211 46.5754 54.4462 40.2454 54.4225 33.6611C54.3703 19.1114 42.4968 7.31431 27.9411 7.36872C20.8952 7.39399 14.2789 10.163 9.31237 15.1653C4.34525 20.1687 1.62347 26.8042 1.64875 33.8496C1.6526 34.9618 1.72623 36.0273 1.86691 37.0181C2.72856 44.1542 6.57026 50.7089 12.4084 55.0182C16.9683 58.3708 22.3706 60.1425 28.034 60.1425H28.1302C30.4469 60.1343 32.7654 59.8194 35.0211 59.2061C35.0926 59.1869 35.1657 59.177 35.2377 59.177ZM47.492 65.5981C45.4609 65.5981 43.0909 65.2778 40.6037 64.2936C38.5721 63.4973 36.6955 62.3604 35.0211 60.9107C32.7632 61.4866 30.4491 61.7828 28.1362 61.7911C22.0656 61.7987 16.3045 59.9287 11.4308 56.3453C5.22723 51.7667 1.14594 44.8004 0.232084 37.2324C0.083164 36.1845 0.00458254 35.0431 0.000186373 33.8562C-0.0267401 26.3695 2.86484 19.3197 8.14244 14.0042C13.4195 8.68866 20.449 5.74708 27.9351 5.72015H28.0367C43.4508 5.72015 56.0161 18.2294 56.0711 33.6556C56.0964 40.579 53.5724 47.2381 48.9597 52.4316C48.6399 53.851 48.5877 55.2671 48.8053 56.6448C49.3686 60.3909 51.709 62.7208 52.6888 63.5495C52.924 63.7479 53.0284 64.0606 52.9608 64.3606C52.8932 64.6607 52.6641 64.8975 52.3668 64.9761C51.2375 65.2734 49.5367 65.5981 47.492 65.5981Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5296 43.6032L26.8557 36.9287H14.2722L5.00342 27.6599L6.16895 26.4944L14.9547 35.2801H27.5382L34.6951 42.4376L33.5296 43.6032Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5095 43.5232C34.54 43.5232 32.9376 45.1256 32.9376 47.0951C32.9376 49.0646 34.54 50.667 36.5095 50.667C38.479 50.667 40.0814 49.0646 40.0814 47.0951C40.0814 45.1256 38.479 43.5232 36.5095 43.5232ZM36.5095 52.3155C33.6311 52.3155 31.2891 49.9735 31.2891 47.0951C31.2891 44.2167 33.6311 41.8746 36.5095 41.8746C39.3879 41.8746 41.73 44.2167 41.73 47.0951C41.73 49.9735 39.3879 52.3155 36.5095 52.3155Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0784 17.1462C13.1089 17.1462 11.5065 18.7486 11.5065 20.7181C11.5065 22.6875 13.1089 24.29 15.0784 24.29C17.0478 24.29 18.6502 22.6875 18.6502 20.7181C18.6502 18.7486 17.0478 17.1462 15.0784 17.1462ZM15.0784 25.9385C12.2 25.9385 9.85791 23.5965 9.85791 20.7181C9.85791 17.8397 12.2 15.4976 15.0784 15.4976C17.9567 15.4976 20.2988 17.8397 20.2988 20.7181C20.2988 23.5965 17.9567 25.9385 15.0784 25.9385Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4237 42.5186L34.0422 28.1365H21.4582L17.8616 24.5394L19.0271 23.3738L22.1412 26.488H34.7247L49.5893 41.3531L48.4237 42.5186Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0088 21.793L31.8433 20.6275L41.9671 10.5031L43.1326 11.6686L33.0088 21.793Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6985 24.1698L39.533 23.0043L47.3647 15.1725L48.5303 16.338L40.6985 24.1698Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60523 49.1966L4.4397 48.0311L9.75246 42.7178L10.918 43.8833L5.60523 49.1966Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9917 59.2012L15.8262 58.0357L25.0625 48.7993L26.2281 49.9648L16.9917 59.2012Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6384 54.2297L9.4729 53.0642L19.8193 42.7178L20.9848 43.8833L10.6384 54.2297Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.354 31.5513L152.112 30.4671L156.242 25.739L157.484 26.8232L153.354 31.5513Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.55 22.9881L142.308 21.9039L146.439 17.1758L147.68 18.26L143.55 22.9881Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.621 14.3428L160.78 28.4583L164.406 24.3078L148.246 10.1923L144.621 14.3428ZM160.937 30.7839L142.294 14.4994L148.089 7.8667L166.732 24.1512L160.937 30.7839Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.09 20.8898L160.861 19.7919L169.808 9.77302C170.494 8.98886 170.412 7.78266 169.621 7.09191L163.929 2.1193C163.545 1.78354 163.05 1.61264 162.547 1.65331C162.039 1.68738 161.576 1.91763 161.241 2.30064L152.287 12.3266L151.057 11.2287L160.005 1.20984C160.624 0.500961 161.489 0.0723347 162.436 0.00804077C163.381 -0.0546046 164.298 0.253127 165.013 0.877383L170.705 5.85C172.181 7.13917 172.333 9.38836 171.044 10.8638L162.09 20.8898Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.066 26.9029C130.625 26.9029 130.183 26.9177 129.738 26.948C124.596 27.2953 119.896 29.6241 116.505 33.5059C113.114 37.3878 111.438 42.3576 111.786 47.5C112.132 52.643 114.462 57.3425 118.344 60.7325C126.357 67.7328 138.571 66.9069 145.57 58.8949C148.961 55.0125 150.637 50.0427 150.29 44.9003C149.943 39.7578 147.614 35.0583 143.732 31.6678C140.186 28.5696 135.731 26.9029 131.066 26.9029ZM131.024 67.1355C126.134 67.1355 121.223 65.4369 117.259 61.9744C113.046 58.2943 110.517 53.1931 110.14 47.6116C109.763 42.029 111.583 36.6349 115.264 32.4217C118.944 28.208 124.045 25.6797 129.627 25.3032C135.207 24.9268 140.603 26.7457 144.816 30.4259C149.03 34.106 151.558 39.2078 151.935 44.7893C152.312 50.3713 150.492 55.7654 146.812 59.9786C142.677 64.7132 136.865 67.1355 131.024 67.1355ZM111.689 29.2983C102.37 39.9678 103.468 56.2297 114.137 65.549C119.305 70.0639 125.918 72.2955 132.769 71.8328C139.616 71.3707 145.872 68.2692 150.387 63.1015C159.706 52.4325 158.608 36.1706 147.939 26.8512C137.27 17.5314 121.008 18.6293 111.689 29.2983ZM130.998 73.5413C124.388 73.5413 118.077 71.18 113.052 66.791C101.699 56.8732 100.53 39.5683 110.447 28.2146C120.365 16.861 137.67 15.6927 149.023 25.6093C160.377 35.5271 161.545 52.8326 151.628 64.1857C146.824 69.6853 140.166 72.9857 132.88 73.4781C132.25 73.5204 131.622 73.5413 130.998 73.5413Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.861 40.7755H123.059V39.127H120.861V40.7755ZM125.257 40.7755H127.455V39.127H125.257V40.7755ZM129.653 40.7755H131.851V39.127H129.653V40.7755ZM134.05 40.7755H136.248V39.127H134.05V40.7755ZM138.446 40.7755H140.644V39.127H138.446V40.7755Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.545 46.8203H145.04V45.1718H139.545V46.8203Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.014 46.8203H134.05V45.1718H117.014V46.8203Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.861 52.865H141.193V51.2164H120.861V52.865Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3962 25.615C68.7983 25.615 68.196 25.6853 67.5998 25.8276C65.6012 26.3035 63.9065 27.5301 62.8283 29.2814C61.7513 31.0316 61.4199 33.0967 61.8958 35.0953C62.3717 37.095 63.5976 38.7886 65.349 39.8657C67.0986 40.9428 69.1637 41.2736 71.1634 40.7971C73.1632 40.3207 74.8579 39.0936 75.9349 37.3429C77.012 35.5932 77.3428 33.5286 76.8669 31.5295C76.391 29.5303 75.1651 27.8367 73.4148 26.7602C72.1861 26.0035 70.803 25.615 69.3962 25.615ZM69.3627 42.6589C67.6548 42.6595 65.976 42.1874 64.4851 41.2692C62.359 39.9619 60.8698 37.905 60.2923 35.4772C59.7142 33.05 60.1164 30.5431 61.4248 28.4175C62.7332 26.2909 64.7907 24.8022 67.2179 24.2236C69.6451 23.6461 72.1537 24.0467 74.2787 25.3562C76.4037 26.6629 77.8923 28.7198 78.4704 31.1476C79.0485 33.5753 78.6468 36.0823 77.339 38.2067C76.0311 40.3328 73.9737 41.822 71.5454 42.4012C70.8211 42.5732 70.0891 42.6589 69.3627 42.6589ZM71.3453 57.5713L68.0471 52.4849C66.9041 52.4074 65.7677 52.2261 64.6571 51.9436L59.9329 55.7392L54.1118 52.1574L54.9757 50.7534L59.8065 53.7257L64.2796 50.1324L64.6873 50.2456C65.9452 50.5956 67.2443 50.8034 68.5488 50.8627L68.9725 50.8814L72.0954 55.6974L77.0499 54.5154L77.667 48.8086L78.0369 48.6009C79.1777 47.9596 80.2443 47.1897 81.2059 46.3127L81.5192 46.0269L87.1303 47.2216L89.7993 42.8831L86.2027 38.4155L86.3165 38.0078C86.666 36.7461 86.8737 35.4465 86.933 34.1441L86.9523 33.721L91.7683 30.5991L90.5896 25.6458L84.8833 25.0275L84.6751 24.6594C84.0283 23.5153 83.2573 22.4492 82.3836 21.4903L82.0984 21.1776L83.2914 15.5659L78.9557 12.8969L74.4858 16.4946L74.0776 16.3803C72.8312 16.0324 71.5322 15.8242 70.2161 15.7621L69.7935 15.7423L66.67 10.929L61.715 12.1094L61.0957 17.8134L60.7275 18.0212C59.5916 18.663 58.5239 19.434 57.554 20.3132L56.4467 19.0916C57.4012 18.2261 58.4426 17.4562 59.5477 16.7996L60.2022 10.7752L67.4196 9.05627L70.7189 14.1404C71.869 14.2196 73.0054 14.4015 74.1083 14.6823L78.8282 10.8823L85.1455 14.7718L83.8854 20.6984C84.6338 21.5579 85.3081 22.4899 85.8961 23.479L91.9238 24.1324L93.6421 31.3498L88.5552 34.6464C88.4777 35.7872 88.2964 36.9241 88.014 38.0364L91.8133 42.7551L87.9249 49.0762L81.9983 47.8145C81.1361 48.5657 80.2031 49.2394 79.215 49.8247L78.5638 55.8496L71.3453 57.5713Z",
    fill: "#67E2C2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.a771790526c120b8fc57027619ed8d8a.svg";
export { ForwardRef as ReactComponent };